export class ConfigData {
    public static data;
}



// WEBPACK FOOTER //
// ./web/static/services/ConfigData.ts